var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsfeedOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22775 3.09998C6.65809 3.09998 5.90843 3.22664 5.14628 3.63424C4.49675 3.98161 3.98161 4.49675 3.63424 5.14628C3.22664 5.90843 3.09998 6.65809 3.09998 8.22775V15.7722C3.09998 17.3419 3.22664 18.0915 3.63424 18.8537C3.98161 19.5032 4.49675 20.0183 5.14628 20.3657C5.90843 20.7733 6.6581 20.9 8.22775 20.9H15.7722C17.3419 20.9 18.0915 20.7733 18.8537 20.3657C19.5032 20.0183 20.0183 19.5032 20.3657 18.8537C20.7733 18.0915 20.9 17.3419 20.9 15.7722V8.22775C20.9 6.6581 20.7733 5.90843 20.3657 5.14628C20.0183 4.49675 19.5032 3.98161 18.8537 3.63424C18.0915 3.22664 17.3419 3.09998 15.7722 3.09998H8.22775ZM5.99516 5.2215C6.35714 5.02791 6.74108 4.89998 8.22775 4.89998H15.7722C17.2589 4.89998 17.6428 5.02791 18.0048 5.2215C18.3406 5.40112 18.5988 5.65931 18.7784 5.99516C18.9664 6.34655 19.0924 6.71862 19.0996 8.1H4.9003C4.90752 6.71862 5.03358 6.34655 5.2215 5.99516C5.40112 5.65931 5.65931 5.40112 5.99516 5.2215ZM4.89998 9.9V15.7722C4.89998 17.2589 5.02791 17.6428 5.2215 18.0048C5.40112 18.3406 5.65931 18.5988 5.99516 18.7784C6.35714 18.972 6.74108 19.1 8.22775 19.1H15.7722C17.2589 19.1 17.6428 18.972 18.0048 18.7784C18.3406 18.5988 18.5988 18.3406 18.7784 18.0048C18.972 17.6428 19.1 17.2589 19.1 15.7722V9.9H4.89998Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsfeedOutline);
export default __webpack_public_path__ + "static/media/newsfeed_outline.1ed7678a6bb9ab4d09048ba05d8ef670.svg";
export { ForwardRef as ReactComponent };